<template>
  <a-drawer placement="left" :closable="false" :visible="visible" @close="onClose">
    <img src="@/assets/logo.png" slot="title" height="22px" />
    <a-menu mode="inline" @click="handleClick">
      <a-menu-item key="/home">
        <span>Homepage</span>
      </a-menu-item>
      <a-sub-menu key="/products">
        <template slot="title">
          <span @click.stop="goProducts">Products</span>
        </template>
        <a-sub-menu :key="item.id" v-for="item in stockSkuCategoryList">
          <template slot="title">
            <span @click.stop="openChange({ key: item.handle })">{{ item.name }}</span>
          </template>
          <a-menu-item :key="child.handle" v-for="child in item.children"> {{ child.name }}</a-menu-item>
        </a-sub-menu>
      </a-sub-menu>
      <a-sub-menu key="/how" title="How It Works">
        <a-menu-item key="/how-it-work">How Printdoor Works</a-menu-item>
        <a-menu-item key="/bulk_order_works"> Bulk Order Works </a-menu-item>
        <a-menu-item key="/affiliate-program"> Affiliate Program </a-menu-item>
      </a-sub-menu>
      <a-sub-menu key="/integrations" title="Integrations">
        <a-menu-item key="/shopify">Shopify</a-menu-item>
        <a-menu-item key="/etsy"> Etsy </a-menu-item>
        <a-menu-item key="/wooCommerce">WooCommerce</a-menu-item>
        <a-menu-item key="/shoplazza">Shoplazza</a-menu-item>
      </a-sub-menu>
      <a-menu-item key="/shipping">
        <span>Shipping</span>
      </a-menu-item>
      <a-menu-item key="/helpCenter">
        <span>Help Center</span>
      </a-menu-item>
      <a-menu-item key="/holiday">
        <span>Festival Collection</span>
      </a-menu-item>
      <a-menu-item key="/activity/graduationSale">
        <!-- <span>Easter Gifts</span> -->
        <span>Graduation Sale</span>
      </a-menu-item>
      <a-menu-item key="/activity/allOverPrint">
        <span>All-Over Print</span>
      </a-menu-item>
    </a-menu>
    <div class="btns" v-if="!token">
      <a-button style="width: 100%;" @click="$router.push('/user/login?type=2')">
        <a-icon type="user" />
        Sign up
      </a-button>
      <a-button style="width: 100%" @click="$router.push('/user/login')">
        <a-icon type="user-add" />
        Sign in
      </a-button>
    </div>
    <div class="btns" v-else>
      <a-button @click="conactUs"> Contact Us </a-button>
      <a-button @click="loginOut" style="background: #FFFFFF; color: #FFA200; border: 1px solid #FFA200;">
        Log Out
      </a-button>
    </div>
  </a-drawer>
</template>

<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'

import { mapState } from 'vuex'
export default {
  name: 'Draw',
  props: ['visible', 'stockSkuCategoryList'],
  watch: {
    visible(val) {
      val && (document.querySelector('#app').style.overflow = 'hidden')
      !val && (document.querySelector('#app').style.overflow = 'auto')
    }
  },
  computed: {
    ...mapState({ token: state => state.user.token })
  },
  methods: {
    loginOut() {
      this.$ls.remove(ACCESS_TOKEN)
      window.location.reload()
    },
    conactUs() {
      window.ssq.push('chatOpen')
    },
    openChange({ key }) {
      this.$router.push(`/products/category/${key}`)
      this.$emit('onclose')
    },
    goProducts() {
      this.$router.push(`/products`)
      this.$emit('onclose')
    },
    handleClick(val) {
      const { keyPath, key } = val
      if (keyPath.includes('/products')) {
        this.$router.push(`/products/category/${key}`)
      } else {
        this.$router.push(key)
      }
      this.$emit('onclose')
    },
    onClose() {
      this.$emit('onclose')
    }
  }
}
</script>

<style lang="less" scoped>
.btns {
  margin-top: 20px;
  /deep/.ant-btn {
    width: 100%;
    margin-bottom: 12px;
    color: white;
    background: #ffa200;
  }
}
</style>
